(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySocialNetworkCustom', CompanySocialNetworkCustom);

    CompanySocialNetworkCustom.$inject = ['$resource'];

    function CompanySocialNetworkCustom($resource) {


        var getCompanySocialNetwork = function () {
            var resourceUrl = 'api/get-company-social-network-infos-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var saveCompanySocialNetworkList = function () {
            var resourceUrl = 'api/save-company-social-network-infos';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {

            getCompanySocialNetwork: getCompanySocialNetwork,
            saveCompanySocialNetworkList: saveCompanySocialNetworkList

        };
    }
})();
